export default class Article {
  id: number;
  created: string;
  image?: string;
  text?: string;
  title: string;
}



// WEBPACK FOOTER //
// /Users/nide/Code/3dissue/3d-issue-hubs-ui/src/app/edit/article.ts